import { clearDraft, loadDraft, saveDraft } from './answerDraft';

/**
 * Черновик сообщения в чате на устройстве (02.10.2026, сборка 1.1.1; техдолг 368 — чат).
 *
 * ⚠️ ЗАЧЕМ. Недописанное сообщение жило только в памяти экрана: ушёл на главную посмотреть задание, свернул
 * приложение, оно было выгружено — и набранный текст пропадал без вопроса.
 *
 * Правила — те же, что у черновика эссе (`lib/writingDraft.ts`): `localStorage`, 14 дней, стирается после
 * отправки. Ключ — с учёткой и диалогом: на общем телефоне чужой текст не должен открыться следующему.
 */

export function chatDraftKey(userId: string | undefined, roomId: string): string {
  return `chat:${userId || 'anon'}:${roomId}`;
}

export function loadChatDraft(key: string): string {
  const text = loadDraft<string>(key);
  return typeof text === 'string' ? text : '';
}

/** Пустой текст черновиком не считается: стёр всё — черновика нет. */
export function saveChatDraft(key: string, text: string): void {
  if (text === '') clearDraft(key);
  else saveDraft(key, text);
}
